import React from "react";
import BackgroundImage from "gatsby-background-image";
import { graphql, useStaticQuery } from "gatsby";
import { down } from "styled-breakpoints";
import { motion } from "framer-motion";
import styled from "styled-components";
import tw from "twin.macro";

const Wrapper = styled(motion.div)<{ natuCase: boolean }>`
  ${tw`
    absolute top-0 left-0 right-0 max-w-1600 h-360 mx-auto
    lg:-top-480 lg:h-480
  `}
  
  ${down('sm')} {
    ${({ natuCase }) => natuCase && `
      div:after, div:before {
        background-position: 50% 50% !important;
      }
    `}
  }
`;

const Background = tw(BackgroundImage)`h-full`;

const CaseBackground = ({ width, name }: { width: number, name: string }) => {
  const { allSanityCases } = useStaticQuery(graphql`
    query {
      allSanityCases {
        nodes {
          slug { current }
          image { asset { fluid(maxWidth: 2000) { ...GatsbySanityImageFluid } } }
        }
      }
    }
  `);
  const data = allSanityCases.nodes.find(item => item.slug.current === name);

  return (
    <Wrapper
      animate={ width >= 1024 && { top: 0 }}
      natuCase={name === 'naturaily'}
      transition={{ duration: .675, delay: .24, ease: [.84, 0, .16, 1] }}
    >
      <Background
        Tag="div"
        fluid={data.image.asset.fluid}
        style={{ backgroundPosition: '90% 50%' }}
      />
    </Wrapper>
  );
};

export default CaseBackground;
